var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React from "react";
import LazyLoad from "react-lazyload";
import classNames from "classnames";
import { SUPPORTED_PLATFORMS } from "./config";
import { embeddedMediaCls, embeddedVideoCls, embeddedInstagramCls } from "./Embedded.less";
var MEDIA_RENDERERS = _defineProperty(_defineProperty(_defineProperty({}, SUPPORTED_PLATFORMS.youtube, function(id, className) {
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames(embeddedMediaCls, embeddedVideoCls, className)
  }, /* @__PURE__ */ React.createElement("iframe", {
    title: "YouTube Embedded Video",
    src: "https://www.youtube.com/embed/".concat(id),
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true
  }));
}), SUPPORTED_PLATFORMS.vimeo, function(id, className) {
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames(embeddedMediaCls, embeddedVideoCls, className)
  }, /* @__PURE__ */ React.createElement("iframe", {
    title: "Vimeo Embedded Video",
    src: "https://player.vimeo.com/video/".concat(id),
    frameBorder: "0",
    allow: "autoplay; fullscreen",
    allowFullScreen: true
  }));
}), SUPPORTED_PLATFORMS.instagram, function(id, className) {
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames(embeddedMediaCls, embeddedInstagramCls, className)
  }, /* @__PURE__ */ React.createElement("iframe", {
    title: "Instagram Embedded Post",
    src: "https://www.instagram.com/p/".concat(id, "/embed"),
    frameBorder: "0",
    scrolling: "no",
    allowFullScreen: true
  }));
});
var EmbeddedMedia = /* @__PURE__ */ __name(function EmbeddedMedia2(_ref) {
  var id = _ref.id, platform = _ref.platform, className = _ref.className, _ref$lazyload = _ref.lazyload, lazyload = _ref$lazyload === void 0 ? null : _ref$lazyload;
  if (!id) {
    throw new Error("No valid id provided for embedded media");
  }
  if (!SUPPORTED_PLATFORMS[platform]) {
    throw new Error("Not supported video platform '".concat(platform, "' passed to <EmbeddedVideo />. Supported video platforms: ").concat(Object.keys(SUPPORTED_PLATFORMS).join(", ")));
  }
  var component = MEDIA_RENDERERS[platform](id, className);
  return lazyload ? /* @__PURE__ */ React.createElement(LazyLoad, lazyload, component) : component;
}, "EmbeddedMedia");
export {
  EmbeddedMedia
};
